import React, { useState, useEffect, useRef } from "react";
import { Modal, message } from "antd";
import { getStorage, setStorage } from "../../../utils/common";
import { hnairChallengeRegister, hnairChallengeProgress, hnairChallengeJoined, loginStatus, hnairVipLevel } from "../../../api";
import "./style.scss";

// 证件类型(后端证件校验按证件号查重, 类型用于前端展示)
const ID_TYPES = [
  { label: "身份证", value: "id" },
  { label: "护照", value: "passport" },
  { label: "其他", value: "other" },
];

// 活动流程(海航金鹏金卡直升挑战)
const FLOW_STEPS = [
  { t: "立即报名", d: "开启挑战" },
  { t: "飞满6航段", d: "银卡365天" },
  { t: "飞满12航段", d: "金卡365天" },
];

// 挑战成功享: 银卡 / 金卡两档, 左右滑动切换。3 项权益与"查看权益"详情表对齐。
// TODO: 图标为占位, 待八大洲/海航出图后替换
const TIERS = [
  {
    key: "silver",
    name: "银卡会员",
    theme: "silver",
    benefits: [
      { icon: "💺", t: "免费升舱机会", d: "国内自营全价票可享" },
      { icon: "🛋️", t: "贵宾休息室", d: "仅限本人部分城市可使用" },
      { icon: "🧳", t: "额外免费行李", d: "20 公斤 / 1 件" },
    ],
  },
  {
    key: "gold",
    name: "金卡会员",
    theme: "gold",
    benefits: [
      { icon: "💺", t: "免费升舱机会", d: "国内自营全价票可享" },
      { icon: "🛋️", t: "贵宾休息室", d: "限本人及同行1人可用" },
      { icon: "🧳", t: "额外免费行李", d: "30 公斤 / 1 件" },
    ],
  },
];

// 权益详情(点"查看权益"弹出): 银卡/金卡逐项对比
const BENEFIT_DETAILS = [
  { label: "免费升舱机会", silver: "国内自营全价票可享", gold: "国内自营全价票可享" },
  { label: "贵宾休息室", silver: "仅限本人部分城市可使用", gold: "限本人及同行1人可用" },
  { label: "客票免变更手续费", silver: "出港前4小时(含)可申请客票变更", gold: "出港前4小时(含)可申请客票变更" },
  { label: "额外免费行李", silver: "20 公斤 / 1 件", gold: "30 公斤 / 1 件" },
  { label: "远机位摆渡车", silver: "机场保障", gold: "搭乘海南航空(HU)、大新华航空(CN)实际承运且挂航空代码的航班，在海口、太原、乌鲁木齐出港可享受头等舱安检通道；在海口、西安、太原、乌鲁木齐、广州、深圳出港可享受远机位贵宾摆渡车送机服务" },
];

// 活动细则。八大洲为报名入口(仅小程序), 不售机票; 挑战航段以实际搭乘海航航班累积。
// TODO: 航段计入口径等最终文案以海航/运营法务确认为准。
const RULES = [
  "参与海航金卡挑战赛活动，若您还不是海南航空金鹏俱乐部会员，报名时需勾选《海航隐私声明》《金鹏俱乐部会员章程及条款》和《授权协议》，并在报名同时注册成为金鹏会员。",
  "本活动通过八大洲小程序报名，仅限八大洲实名认证会员本人参加，须使用与金鹏会员信息一致的实名认证证件报名。",
  "八大洲仅提供本活动的报名入口（小程序），不涉及机票销售；报名成功后，挑战航段以您本人实际搭乘海南航空及旗下航司承运的航班为准，由金鹏俱乐部系统按会员卡号自动累积，不限机票预订渠道。",
  "报名参加金卡挑战赛的用户，在挑战期内完成金卡挑战后，预计 10 个工作日内发放金卡；活动结束时未完成金卡挑战但已完成银卡挑战的，活动结束后 10 个工作日内默认发放银卡；挑战期内已达到银卡标准的，可向海南航空申请中止金卡挑战并发放银卡。超出挑战标准的定级积分 / 定级航段在升级成功后自动清零，不予滚动。",
  "航段计入挑战需同时满足：①以报名所用证件对应的金鹏会员本人身份实际乘机；②证件信息与金鹏会员信息一致；③航班为本活动适用的海南航空及旗下航司承运航班。",
  "退票、废票及非活动适用航班的航段，不计入挑战统计；已计入后发生退改等异常的，海南航空有权相应扣减对应航段。",
  "挑战航段及积分以海南航空金鹏俱乐部系统最终确认为准，因值机、离港数据回传可能存在延迟，进度更新以系统实际到账时间为准。",
  "同一证件、同一金鹏会员号在本活动中仅可报名参加一次金卡挑战，重复报名以首次成功报名为准。",
  "如以不正当手段参与活动（如虚假交易、恶意刷段、倒买倒卖、有组织的众包作弊等），主办方及海南航空有权在不事先通知的情况下取消参与资格、收回已发放权益，必要时追究相应责任。",
  "为提供更好的服务体验，主办方在法律允许的范围内可能对活动内容及条款做适当调整，并在本页面公示。",
  "对本次活动如有疑问，可致电海南航空客服 95339 转 8 了解详情。",
];

// 海航金鹏等级 英文→中文(未知等级保留原值)
const TIER_LABELS = {
  STANDARD: "普通会员",
  SILVER: "银卡",
  GOLD: "金卡",
  GOLDEN: "金卡",
  PLATINUM: "白金卡",
};
function tierLabel(t) {
  if (!t) return "";
  return TIER_LABELS[String(t).toUpperCase()] || t;
}

export default (props) => {
  // 登录态以 isLogin 接口为准: 仅凭 token 是否存在会把"过期/失效 token"误判为已登录,
  // 导致未登录也能打开表单、填完提交才 401。默认 false, 进页面异步校验。
  const [loggedIn, setLoggedIn] = useState(false);
  // 已参与: 进页面由后端 joined 接口取真实态(见下), localStorage 仅作首屏乐观值
  const [joined, setJoined] = useState(!!getStorage("hnairChallengeJoined"));
  // 八大洲会员等级(橙卡1/银卡2/金卡3/黑金卡4); 银卡及以上(>=2)才可参与; null=未取到暂不拦
  const [vipLevel, setVipLevel] = useState(null);

  const [formVisible, setFormVisible] = useState(false);
  const [progressVisible, setProgressVisible] = useState(false);
  const [progress, setProgress] = useState(null);
  const [benefitVisible, setBenefitVisible] = useState(false); // 权益详情弹窗

  // 银卡/金卡轮播
  const tierTrackRef = useRef(null);
  const [tierIdx, setTierIdx] = useState(0);

  // 内联报名按钮滚出视口后, 底部悬浮按钮接替
  const inlineCtaRef = useRef(null);
  const [showFloatCta, setShowFloatCta] = useState(false);

  // 报名表单
  const [idType, setIdType] = useState("id");
  const [idNo, setIdNo] = useState("");
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [phone, setPhone] = useState("");
  const [agree, setAgree] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const submittingRef = useRef(false); // 防重复提交同步锁(state 更新有延迟, 快速连点用 ref 拦)

  // 进页面拉真实登录态(活动页可浏览, 不强制跳登录; 仅驱动按钮文案 + 拦在表单之前)。
  // 已登录再查: ①是否已报名(替代 localStorage, 跨设备可靠) ②八大洲会员等级(银卡2及以上才可参与)。
  // 进度所需 cid 由后端按 vip 自查, 前端不碰。
  useEffect(() => {
    loginStatus()
      .then((res) => {
        const isIn = !!(res && res.data && res.data.loginStatus);
        setLoggedIn(isIn);
        if (!isIn) return;
        hnairChallengeJoined()
          .then((r) => setJoined(!!(r && r.data && r.data.joined)))
          .catch(() => {});
        hnairVipLevel()
          .then((r) => setVipLevel(Number((r && r.data && r.data.level) || 0)))
          .catch(() => {});
      })
      .catch(() => setLoggedIn(false));
  }, []);

  // 监听内联报名按钮: 滚出视口即展示底部悬浮按钮
  useEffect(() => {
    const el = inlineCtaRef.current;
    if (!el || typeof IntersectionObserver === "undefined") return undefined;
    const io = new IntersectionObserver(
      (entries) => setShowFloatCta(!entries[0].isIntersecting),
      { threshold: 0 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  function onTierScroll(e) {
    const el = e.target;
    const idx = Math.round(el.scrollLeft / el.clientWidth);
    if (idx !== tierIdx) setTierIdx(idx);
  }
  function goTier(i) {
    const el = tierTrackRef.current;
    if (el) el.scrollTo({ left: i * el.clientWidth, behavior: "smooth" });
  }

  // 进度: cid 由后端按登录 vip 自查, 前端不传
  function loadProgress() {
    hnairChallengeProgress()
      .then(({ data }) => setProgress(data || null))
      .catch(() => {});
  }

  // 参与门槛: 八大洲银卡(2)及以上; vipLevel 未取到(null)时暂不拦(乐观)。
  // 已参与优先于门槛: joined 用户当初已满足条件, 直接放行看进度, 不受当前等级影响。
  const eligible = vipLevel === null || vipLevel >= 2;
  const ctaDisabled = loggedIn && !joined && !eligible;

  // 底部 CTA 文案 + 行为(未登录 / 已参与 / 不符合条件 / 默认)
  function ctaText() {
    if (!loggedIn) return "登录参与挑战";
    if (joined) return "查看挑战进度";
    if (!eligible) return "未符合活动参与条件";
    return "立即报名";
  }
  // 跳登录并带回跳地址, 登录后返回本活动页
  function goLogin() {
    const redirect = `${window.location.pathname}${window.location.search}`;
    props.history.push(`/login?redirect=${encodeURIComponent(redirect)}`);
  }
  function onCta() {
    if (ctaDisabled) return; // 未达银卡, 置灰不可点
    if (!loggedIn) {
      goLogin();
      return;
    }
    if (joined) {
      setProgressVisible(true);
      loadProgress();
      return;
    }
    setFormVisible(true);
  }

  // 提交报名: 后端做海航证件校验拿卡号 -> 提交金卡挑战报名(级别后端固定, 前端不传)
  function onSubmit() {
    if (submittingRef.current) return; // 防重复提交: 同步锁, 快速连点也拦得住
    if (!loggedIn) {
      goLogin();
      return;
    }
    if (!idNo.trim()) {
      message.error("请输入证件号码");
      return;
    }
    if (!agree) {
      message.error("请先阅读并同意相关协议");
      return;
    }
    submittingRef.current = true;
    setSubmitting(true);
    hnairChallengeRegister(idNo.trim())
      .then((res) => {
        if (res && String(res.code) === "200000") {
          message.success("报名成功", 2);
          setJoined(true);
          setStorage("hnairChallengeJoined", true);
          setFormVisible(false);
          setProgressVisible(true);
          loadProgress();
        } else {
          message.error((res && res.msg) || "报名失败");
        }
      })
      .catch((err) => {
        const d = (err && err.response && err.response.data) || {};
        message.error(d.msg || d.t_err || "报名失败, 请稍后再试");
      })
      .finally(() => {
        setSubmitting(false);
        submittingRef.current = false;
      });
  }

  let ctaMod = loggedIn && !joined ? "" : "alt";
  if (ctaDisabled) ctaMod = "disabled";
  const ctaClass = `hc-cta ${ctaMod}`;

  return (
    <div className="hnair-challenge">
      {/* 活动流程 */}
      <div className="hc-card hc-flow">
        <div className="hc-flow-head">
          <span className="hc-gem">◆</span>八大洲用户活动流程
        </div>
        <div className="hc-steps">
          {FLOW_STEPS.map((s, i) => (
            <div className="hc-step" key={i}>
              {i > 0 && <span className="hc-step-line" />}
              <div className="hc-step-body">
                <div className="hc-step-pill">{s.t}</div>
                <div className="hc-step-desc">{s.d}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 挑战成功享: 银卡 / 金卡 左右滑动切换 */}
      <div className="hc-card hc-tier-card">
        <div className="hc-tier-track" ref={tierTrackRef} onScroll={onTierScroll}>
          {TIERS.map((tier) => (
            <div className="hc-tier-slide" key={tier.key}>
              <div className={`hc-tier hc-tier--${tier.theme}`}>
                <span className="hc-tier-badge">挑战成功享</span>
                <div className="hc-tier-main">
                  <span className="hc-tier-name">{tier.name}</span>
                  <span className="hc-tier-air">海南航空</span>
                </div>
                <span className="hc-tier-right" onClick={() => setBenefitVisible(true)}>查看权益 ›</span>
              </div>
              <div className="hc-benefits">
                {tier.benefits.map((b, j) => (
                  <div className="hc-benefit-item" key={j}>
                    <div className="hc-benefit-icon">{b.icon}</div>
                    <div className="hc-benefit-t">{b.t}</div>
                    <div className="hc-benefit-d">{b.d}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="hc-dots">
          {TIERS.map((t, i) => (
            <span
              key={t.key}
              className={`hc-dot ${i === tierIdx ? "on" : ""}`}
              onClick={() => goTier(i)}
            />
          ))}
        </div>
      </div>

      {/* 内联报名按钮(滚出视口后由底部悬浮按钮接替) */}
      <div className={ctaClass} ref={inlineCtaRef} onClick={onCta}>
        {ctaText()}
      </div>

      {/* 活动时间 */}
      <div className="hc-card hc-info">
        <div className="hc-info-title">活动时间</div>
        <div className="hc-info-row">挑战周期：报名后 120 天</div>
      </div>

      {/* 活动日期。TODO: 确认八大洲渠道活动起止日期 */}
      <div className="hc-card hc-info">
        <div className="hc-info-title">活动日期</div>
        <div className="hc-info-text">2026 年 9 月 1 日 至 2026 年 12 月 31 日</div>
      </div>

      {/* 活动内容。TODO: 补充正式活动内容文案 */}
      <div className="hc-card hc-info">
        <div className="hc-info-title">活动内容</div>
        <div className="hc-info-text">
          报名参与海航金鹏「金卡直升挑战」，挑战期内飞满对应航段，即可直升银卡 / 金卡会员，尊享贵宾权益。
        </div>
      </div>

      {/* 活动细则(最外层) */}
      <div className="hc-card hc-rules">
        <div className="hc-info-title">活动细则</div>
        <div className="hc-rules-list">
          {RULES.map((r, i) => (
            <p className="hc-rule" key={i}>
              <span className="hc-rule-no">{i + 1}.</span>
              {r}
            </p>
          ))}
        </div>
      </div>

      {/* 底部悬浮报名按钮(内联按钮滚出视口时出现) */}
      {showFloatCta && (
        <div className="hc-cta-float">
          <div className={ctaClass} onClick={onCta}>
            {ctaText()}
          </div>
        </div>
      )}

      {/* 权益详情弹窗(点"查看权益") */}
      <Modal
        title="权益详情"
        open={benefitVisible}
        onCancel={() => setBenefitVisible(false)}
        footer={null}
        centered
        wrapClassName="hc-modal hc-benefit-modal"
      >
        <div className="hc-bd-table">
          <div className="hc-bd-row hc-bd-head">
            <div className="hc-bd-c hc-bd-c0">会员权益</div>
            <div className="hc-bd-c">银卡</div>
            <div className="hc-bd-c">金卡</div>
          </div>
          {BENEFIT_DETAILS.map((b, i) => (
            <div className="hc-bd-row" key={i}>
              <div className="hc-bd-c hc-bd-c0">{b.label}</div>
              <div className="hc-bd-c">{b.silver}</div>
              <div className="hc-bd-c">{b.gold}</div>
            </div>
          ))}
        </div>
      </Modal>

      {/* 报名表单弹窗 */}
      <Modal
        title="请填写实名信息"
        open={formVisible}
        onCancel={() => setFormVisible(false)}
        footer={null}
        centered
        wrapClassName="hc-modal"
      >
        <div className="hc-form">
          <div className="hc-field">
            <span className="hc-label">证件类型</span>
            <select className="hc-select" value={idType} onChange={(e) => setIdType(e.target.value)}>
              {ID_TYPES.map((t) => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </select>
          </div>
          <div className="hc-field">
            <span className="hc-label">证件号码</span>
            <input className="hc-input" value={idNo} onChange={(e) => setIdNo(e.target.value)} placeholder="与乘机证件一致" />
          </div>
          {/* 姓/名/手机号: 与实名流程一致而收集, 后端 register 目前只用 id_no */}
          <div className="hc-field">
            <span className="hc-label">姓</span>
            <input className="hc-input" value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="与乘机证件一致" />
          </div>
          <div className="hc-field">
            <span className="hc-label">名</span>
            <input className="hc-input" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="与乘机证件一致" />
          </div>
          <div className="hc-field">
            <span className="hc-label">手机号码</span>
            <input className="hc-input" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="请输入手机号" />
          </div>

          <div className="hc-agree">
            <input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} />
            <span onClick={() => setAgree(!agree)}>阅读并同意</span>
            {/* TODO: 替换为正式活动协议链接 */}
            <span className="hc-link" onClick={() => props.history.push("/member/registerAgreement")}>《相关协议》</span>
          </div>

          <div className={`hc-submit ${submitting ? "disabled" : ""}`} onClick={submitting ? undefined : onSubmit}>
            {submitting ? "提交中..." : "立即报名"}
          </div>
        </div>
      </Modal>

      {/* 挑战进度弹窗 */}
      <Modal
        title="挑战进度"
        open={progressVisible}
        onCancel={() => setProgressVisible(false)}
        footer={null}
        centered
        wrapClassName="hc-modal"
      >
        {progress ? (
          <div className="hc-progress">
            <div className="hc-progress-row"><span>当前等级</span><b>{tierLabel(progress.tier_name) || "-"}</b></div>
            <div className="hc-progress-row"><span>挑战目标</span><b>{tierLabel(progress.challenge_goal) || "金卡"}</b></div>
            <div className="hc-progress-row"><span>是否挑战中</span><b>{progress.in_challenge ? "是" : "否"}</b></div>
            <div className="hc-progress-row"><span>航段（已累积/所需）</span><b>{progress.challenge_segments || 0} / {progress.need_challenge_segments || 0}</b></div>
            <div className="hc-progress-row"><span>里程（已累积/所需）</span><b>{progress.challenge_point || 0} / {progress.need_challenge_point || 0}</b></div>
            <div className="hc-progress-row"><span>挑战截止</span><b>{progress.challenge_end_date || "-"}</b></div>
          </div>
        ) : (
          <div className="hc-progress-empty">暂无进度数据</div>
        )}
      </Modal>
    </div>
  );
};
